module.exports = __webpack_public_path__ + "img/inspiration-5@2x.ab32692.jpg";